import React from 'react';
import { connect } from 'react-redux';

import Setting from './ScheduleChange/Setting';
import SettingReadOnly from './ScheduleRead/SettingReadOnly';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import classes from './ScheduleSetting.css';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class ScheduleSetting extends React.Component{


    constructor(props) {
        super(props);
        this.state = {
            isChangingSchedule: false
        }
    }

    handleQuestion = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui'>
                    <div className={classes.Question}>
                    <Container>
                        <Row>
                            <Col>
                            <h3>Is this repeated?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>The schedule here is repeated. You are supposed to select your weekly availability.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <h3>Why recurring?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>The idea behind BookMeeY is to use fragmentary time to connect with friends. Most of these fragmentary time is repeated each week, like driving to work, or walking your pets. </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <h3>What if I am busy?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>You can simply uncheck all the days in a week to mark you unavailable. Noted, this won't affect the appointments that have been booked by your friends.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <h3>Multiple slots a day?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>We are going to add this funtionality soon.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button variant="outline-info" onClick={onClose} block>I see</Button>
                            </Col>
                        </Row>
                    </Container>
                    </div>

                </div>
              );
            }
          });

    }

    switchState = () => {
        this.setState({isChangingSchedule: !this.state.isChangingSchedule});
    }

    render() {
        let content;
        if (this.state.isChangingSchedule) {
            content = <Setting callBack={this.switchState} isMobile={this.props.isMobile} questionCallback={this.handleQuestion}></Setting>;
        }
        else {
            content = <SettingReadOnly callBack={this.switchState} isMobile={this.props.isMobile} questionCallback={this.handleQuestion}></SettingReadOnly>;
        }
        return (
            <Container>
                <Row>
                    { content }
                </Row>
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (ScheduleSetting);


// WEBPACK FOOTER //
// ./src/containers/Profile/Setting/ScheduleSetting.js